import getApi from '../../../api/apisauceConfig'

export const duplicateUserContent = (userSourceId: string, userDestinationId: string) =>
  getApi().post<null>('/admin/clone/content/users', {
    userSourceId,
    userDestinationId,
  })
